import { PaginatorDynamicDatasource } from '@/shared/resources/datasources/paginator/paginator-dynamic-datasource'
import incidentServices from '@/api/resources/incident/incidentServices'
import { IDENTIFIER_SCOPES } from '@/api/resources/identifierScopesResource'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

export class IncidentDatasource<T> extends PaginatorDynamicDatasource<T> {
    constructor(url: string) {
        super(incidentServices, url)
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        return this.service.paginator(filterModel, params, this._url)
    }

    // TODO: move this out of datasource
    static getPatientCenterIdentifier(patient: any): any {
        if (patient?.patientIdentifiers != null) {
            const centerIds =
                patient.patientIdentifiers.filter(
                    (pai: any) => pai.identifierType.idtScope === IDENTIFIER_SCOPES.CENTER_PATIENT)
            if (centerIds.length) {
                return centerIds[0].paiIdentifier
            }
        }
        return ''
    }
}
